module.exports = __webpack_public_path__ + "static/media/facundo_cambeses.cbc895bc.jpg";